import image from './samples/dog.jpeg'
import video from './samples/video.mp4'

export { image, video }
